<template>
  <QuestionBase
      :question="question"
      :valid="!!(valueFirst && valueLast)"
      :errors="errors"
  >
    <div class="question-multipart-wrapper d-flex flex-wrap align-items-end">
      <div class="question question-multipart field-33">
        <InputBasic
            :value="valueFirst"
            @input="$emit('inputFirst', $event)"
            ref="firstName"
            :args="firstInputOptions"
            :db="db.first"
            :skipped="skipped"
            :no-save="noSave"
            @skipped="skipped=$event"
            @serverErrors="serverErrors.firstName=$event"
            @jsErrors="jsErrors=$event"
        />

      </div>
      <div class="question question-multipart field-33">
        <InputBasic
            :value="valueMiddle"
            @input="$emit('inputMiddle', $event)"
            ref="middleName"
            :args="middleInputOptions"
            :db="db.middle"
            :skipped="skipped"
            :no-save="noSave"
            @skipped="skipped=$event"
            @serverErrors="serverErrors.middleName=$event"
            @jsErrors="jsErrors=$event"
        />
      </div>
      <div class="question question-multipart field-33">
        <InputBasic
            :value="valueLast"
            @input="$emit('inputLast', $event)"
            ref="lastName"
            :args="lastInputOptions"
            :db="db.last"
            :skipped="skipped"
            :serverErrors="serverErrors"
            :no-save="noSave"
            @skipped="skipped=$event"
            @serverErrors="serverErrors.lastName=$event"
            @jsErrors="jsErrors=$event"
        />
      </div>
    </div>
  </QuestionBase>
</template>

<script>
import {skipHelpers} from "../../helpers/skipHelpers";
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "../../../inputs/InputBasic";

export default {
  name: 'FullName',
  components: {
    InputBasic,
    QuestionBase
  },
  mixins: [skipHelpers, questionLoadHelpers],
  props: {
    valueFirst: {
      type: String,
      required: false
    },
    valueMiddle: {
      type: String,
      required: false
    },
    valueLast: {
      type: String,
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    saveLocation: {
      type: String,
      default: 'client_client'
    }
  },
  computed: {
    errors() {
      return [...this.serverErrors.lastName, ...this.serverErrors.middleName, ...this.serverErrors.firstName, ...this.jsErrors]
    }
  },
  data() {
    return {
      question: {
        title: 'What is your full name?',
        subTitle: 'Enter your name as it appears on your birth certificate or other identification.',
        tip: null
      },
      firstInputOptions: {
        placeholder: 'e.g. Joesph',
        label: 'First Name:',
        type: 'text',
      },
      middleInputOptions: {
        placeholder: 'e.g. Richard',
        label: 'Middle Name(s):',
        type: 'text',
      },
      lastInputOptions: {
        placeholder: 'e.g. Blogs',
        label: 'Last Name:',
        type: 'text'
      },
      db: {
        saveLocation: this.saveLocation,
        saveField: 'profileNameFirst',
        first: {
          saveLocation: this.saveLocation,
          saveField: 'profileNameFirst',
        },
        middle: {
          saveLocation: this.saveLocation,
          saveField: 'profileNameMiddle',
        },
        last: {
          saveLocation: this.saveLocation,
          saveField: 'profileNameLast',
        },
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: {
        firstName: [],
        lastName: [],
        middleName: []
      },
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
